// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   PillCard — compact golden card
   Face: icon, ability, drug, drug class
   Hover: swaps face content for details
   Action button always accessible
   ============================================ */

.pill-card {
  --pill-accent: #6366f1;
  position: relative;
  width: 172px;
  display: flex;
  flex-direction: column;
  background: var(--bg-card, rgba(255,255,255,0.03));
  border: 1px solid var(--border-default, rgba(255,255,255,0.08));
  border-radius: var(--radius-lg, 10px);
  padding: 0.65rem 0.6rem 0.5rem;
  overflow: hidden;
  cursor: default;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;
}

/* Accent stripe */
.pill-card::before {
  content: '';
  position: absolute;
  top: 0; left: 0; bottom: 0;
  width: 3px;
  background: var(--pill-accent);
}

/* Type colors */
.pill-card--combat    { --pill-accent: #ef4444; }
.pill-card--passive   { --pill-accent: #6366f1; }
.pill-card--consumable{ --pill-accent: #a855f7; }

/* Hover lift + glow */
.pill-card:hover {
  border-color: rgba(251, 191, 36, 0.3);
  box-shadow: 0 6px 24px rgba(0,0,0,0.35), 0 0 12px rgba(251,191,36,0.08);
  transform: translateY(-2px);
}

.pill-card--clickable { cursor: pointer; }

/* ── Status badge (top-right) ── */
.pill-card__badge {
  position: absolute;
  top: 5px; right: 5px;
  font-size: 7px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 1px 5px;
  border-radius: 3px;
  z-index: 2;
}
.pill-card__badge--starter   { background: rgba(234,179,8,0.15); color: #fbbf24; }
.pill-card__badge--owned     { background: rgba(34,197,94,0.15); color: #4ade80; }
.pill-card__badge--equipped  { background: rgba(99,102,241,0.15); color: #818cf8; }

/* ============================================
   CONTENT AREA — face and hover swap in place
   ============================================ */

/* Face and hover stack in the same grid cell so the taller of the two
   reserves the height. Toggling \`visibility\` (instead of \`display\`) keeps
   the reserved space stable, so hovering can no longer shift the card's
   height. The non-visible layer stays out of the pointer/a11y tree via
   \`visibility: hidden\` (children also hidden), with \`pointer-events: none\`
   for belt-and-braces. */
.pill-card__content {
  flex: 1 1;
  min-height: 0;
  position: relative;
  display: grid;
  grid-template-areas: "swap";
}

.pill-card__face,
.pill-card__hover {
  grid-area: swap;
  display: flex;
  flex-direction: column;
  padding: 0.15rem 0 0.35rem;
  min-width: 0;
  max-width: 100%;
}

.pill-card__face {
  align-items: center;
  text-align: center;
  gap: 0.25rem;
  visibility: visible;
  pointer-events: auto;
}

.pill-card__hover {
  gap: 0.3rem;
  visibility: hidden;
  pointer-events: none;
}

.pill-card:hover .pill-card__face {
  visibility: hidden;
  pointer-events: none;
}

.pill-card:hover .pill-card__hover {
  visibility: visible;
  pointer-events: auto;
}

/* Suppress the hover-swap entirely (face stays visible) */
.pill-card--no-hover .pill-card__hover,
.pill-card--no-hover:hover .pill-card__hover {
  visibility: hidden !important;
  pointer-events: none !important;
}
.pill-card--no-hover:hover .pill-card__face {
  visibility: visible;
  pointer-events: auto;
}

/* Icon ring */
.pill-card__icon-ring {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: color-mix(in srgb, var(--pill-accent) 12%, transparent);
  border: 1px solid color-mix(in srgb, var(--pill-accent) 25%, transparent);
  color: var(--pill-accent);
  flex-shrink: 0;
}

.pill-card__icon-ring svg {
  width: 16px;
  height: 16px;
}

/* Ability name */
.pill-card__ability {
  font-size: 0.72rem;
  font-weight: 650;
  color: var(--text-primary, #fff);
  line-height: 1.15;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Drug name */
.pill-card__drug-name {
  font-size: 0.62rem;
  color: var(--pill-accent);
  font-weight: 600;
  letter-spacing: 0.01em;
  opacity: 0.85;
}

/* Drug class */
.pill-card__drug-class {
  font-size: 0.55rem;
  color: var(--text-muted, #9ca3af);
  line-height: 1.3;
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* ── Footer: type + (optional inline foot action) + cost ── */
.pill-card__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: auto;
  padding-top: 0.3rem;
  border-top: 1px solid rgba(255,255,255,0.04);
}

.pill-card__foot-action {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 6px;
  margin-left: auto;
}

.pill-card__type {
  font-size: 0.55rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 1px 5px;
  border-radius: 3px;
}
.pill-card__type--combat    { background: rgba(239,68,68,0.12); color: #f87171; }
.pill-card__type--passive   { background: rgba(99,102,241,0.12); color: #818cf8; }
.pill-card__type--consumable{ background: rgba(168,85,247,0.12); color: #c084fc; }
.pill-card__type--gold      { background: rgba(251,191,36,0.16); color: #fbbf24; }

.pill-card__cost {
  font-size: 0.6rem;
  font-weight: 700;
  color: #fbbf24;
}
.pill-card__cost--free { color: #4ade80; }

/* ============================================
   HOVER CONTENT
   ============================================ */

/* Hover description */
.pill-card__hover-desc {
  font-size: 0.62rem;
  color: var(--text-secondary, #d1d5db);
  line-height: 1.4;
  margin: 0;
}

/* HTN authored effect grammar. The outer combat-status-rail class supplies the
   exact status-chip colors; this modifier turns that rail into the drug card's
   vertical row block without introducing replacement chip chrome. */
.pill-card__influence-rows.combat-status-rail {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 8px;
  min-height: 0;
  margin: 0.2rem 0 0;
  padding: 0.5rem 0 0;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0;
  background: none;
  color: var(--text-secondary, #d1d5db);
  font-size: 0.68rem;
  line-height: 1.35;
}

.pill-card__influence-row {
  min-width: 0;
}

.pill-card__influence-row--regen {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 0;
}

.pill-card__influence-verb,
.pill-card__influence-rows .gt-text {
  color: var(--text-secondary, #d1d5db);
  font-weight: 700;
}

.pill-card__influence-row--warden {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 7px 0;
}

.pill-card__warden-mini {
  flex: 1 1 auto;
  grid-template-columns: minmax(112px, 1fr);
  min-width: 0;
  margin-top: 0;
}

.pill-card--side-details-layout .pill-card__influence-row--warden {
  display: grid;
  grid-template-columns: minmax(112px, 0.42fr) minmax(142px, 1fr);
  align-items: center;
  gap: 14px;
}

.pill-card__influence-rows .gt-inflicts {
  padding: 7px 0;
}

.pill-card__influence-rows .gt-inflicts__r {
  max-width: 58%;
}

/* ── Authored HTN starter drug-toast rows (kc-pill family) ──────────────────
   Faithful port of ref-toasts/antihtn-authored-2026-07-19.html. Every row is a
   uniform label-left / tag-right space-between line; verbs are semantic-colored;
   potassium/HR/diuresis render the shared reference \`kc-pill\` chrome. */
.pill-card__influence-rows .pill-card__influence-row--kc {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 0;
}

.pill-card__influence-rows .pill-card__influence-verb {
  margin: 0;
  font-weight: 700;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
}
.pill-card__influence-rows .pill-card__influence-verb--regen { color: #86efac; }
.pill-card__influence-rows .pill-card__influence-verb--strong { color: #f87171; }
.pill-card__influence-rows .pill-card__influence-verb--weak { color: #fb923c; }
.pill-card__influence-rows .pill-card__influence-verb--influences { color: #d1d5db; }

/* Regen chip right group: [hp chip] / round */
.pill-card__influence-rows .pill-card__influence-row--kc .gt-inflicts__r {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  max-width: none;
  flex: 0 0 auto;
}

/* Qualifier group: "( <glyph> compensatory )" / "( <glyph> 5 )" */
.pill-card__influence-rows .kc-qual {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: #9ca3af;
  font-weight: 700;
  margin-left: 3px;
}
.pill-card__influence-rows .kc-qual__inner {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.pill-card__influence-rows .kc-qual__inner--hr { color: #fb7185; }
.pill-card__influence-rows .kc-qual__inner--diuresis { color: #2dd4bf; gap: 3px; }
/* Remodel takes the sympathetic-axis green (AXIS_DEFAULTS.beta accent), the same
   colour its own effect chip paints, so the qualifier and the chip read as one
   claim rather than two. Compensatory is rose because heart RATE is rose; Remodel
   is not a heart-rate claim and must not borrow that colour. */
.pill-card__influence-rows .kc-qual__inner--remodel { color: #4ade80; }
/* Mortality Benefit takes the Good Outcome teal its own chip paints (the
   CanonicalEffectChip tone="good" accent, 45,212,160), so the qualifier and the
   chip read as one claim. It is a HEAL, so it must not borrow Remodel's green. */
.pill-card__influence-rows .kc-qual__inner--mortality { color: #2dd4a0; }
.pill-card__influence-rows .kc-qual__glyph { display: inline-block; vertical-align: middle; }
.pill-card__influence-rows .kc-qual__num { font-variant-numeric: tabular-nums; }

/* Weaken-row enemy mini: right-aligned fixed-width ledger, per the reference */
.pill-card__influence-rows .pill-card__hover-tags--ledger {
  flex: 0 0 228px;
  max-width: 228px;
  margin: 0;
  display: block;
}
.pill-card__influence-rows .pill-card__hover-tags--ledger .pill-card__warden-mini {
  width: 100%;
  grid-template-columns: 1fr;
  flex: 1 1 auto;
}

/* Hover tags */
.pill-card__hover-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  min-width: 0;
  max-width: 100%;
}

.pill-card__htag {
  font-size: 0.55rem;
  font-weight: 600;
  padding: 1px 5px;
  border-radius: 3px;
  max-width: 100%;
  white-space: normal;
  overflow-wrap: anywhere;
}
.pill-card__htag--pro  { background: rgba(34,197,94,0.15); color: #4ade80; }
.pill-card__htag--con  { background: rgba(239,68,68,0.15); color: #f87171; }
.pill-card__htag--mech { background: rgba(245,158,11,0.12); color: #fbbf24; }

/* Achievement requirement in hover */
.pill-card__hover-req {
  display: flex;
  align-items: center;
  gap: 4px;
  border-top: 1px solid rgba(255,255,255,0.05);
  padding-top: 0.25rem;
}

.pill-card__hover-req-name {
  font-size: 0.5rem;
  color: var(--text-muted, #9ca3af);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 55%;
}

.pill-card__hover-req-bar {
  flex: 1 1;
  height: 3px;
  background: rgba(255,255,255,0.06);
  border-radius: 2px;
  overflow: hidden;
}

.pill-card__hover-req-fill {
  height: 100%;
  background: var(--text-muted, #9ca3af);
  border-radius: 2px;
  transition: width 0.3s ease;
}

.pill-card__hover-req-label {
  font-size: 0.5rem;
  color: var(--text-subtle, #6b7280);
  white-space: nowrap;
}

/* ── Action button (always visible, never covered) ── */
.pill-card__action {
  margin-top: 0.3rem;
}
.pill-card__action > * { width: 100%; }

/* ── Mini variant ── */
.pill-card--mini {
  width: 140px;
  padding: 0.5rem;
}
.pill-card--mini .pill-card__icon-ring {
  width: 26px; height: 26px;
}
.pill-card--mini .pill-card__icon-ring svg {
  width: 13px; height: 13px;
}
.pill-card--mini .pill-card__drug-class {
  -webkit-line-clamp: 1;
}

/* ============================================
   SIDE-DETAILS variant — effect details slide OUT to the right on hover,
   the compact face stays put and fixed-size. Used by the skill-tree node
   toast so a gold card reveals "what it does" without growing or flipping.
   ============================================ */

/* Let the side panel escape the card's clip; round the accent stripe so the
   now-visible corners follow the card radius. */
.pill-card--side-details { overflow: visible; }
.pill-card--side-details::before {
  border-top-left-radius: var(--radius-lg, 10px);
  border-bottom-left-radius: var(--radius-lg, 10px);
}

/* With the details lifted out of the grid, only the face reserves height →
   the card stays compact regardless of how much detail a card carries. */
.pill-card--side-details .pill-card__face {
  visibility: visible;
  pointer-events: auto;
}
.pill-card--side-details:hover .pill-card__face {
  visibility: visible;
  pointer-events: auto;
}

/* The details block becomes a floating panel anchored to the card's right
   edge. Hidden until hover, then slides in. */
.pill-card--side-details .pill-card__hover {
  position: absolute;
  grid-area: unset;
  top: -2px;
  left: calc(100% + 12px);
  width: 210px;
  max-width: none;  /* override the base .pill-card__hover max-width:100% (would cap
                       the floating panel to the card's inner width ~151px) */
  padding: 0.6rem 0.65rem;
  background: linear-gradient(180deg, rgba(20,20,24,0.98), rgba(12,12,15,0.98));
  border: 1px solid color-mix(in srgb, var(--pill-accent) 28%, rgba(255,255,255,0.08));
  border-radius: var(--radius-md, 8px);
  box-shadow: 0 10px 32px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4),
              -8px 0 24px rgba(0,0,0,0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 60;
  visibility: hidden;
  opacity: 0;
  transform: translateX(-6px);
  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s;
}

/* Little notch / accent rail on the panel's left edge facing the card. */
.pill-card--side-details .pill-card__hover::before {
  content: '';
  position: absolute;
  top: 10px; bottom: 10px; left: -1px;
  width: 2px;
  border-radius: 2px;
  background: var(--pill-accent);
  opacity: 0.85;
}

.pill-card--side-details:hover .pill-card__hover {
  visibility: visible;
  opacity: 1;
  transform: translateX(0);
  pointer-events: auto;
}

/* Panel header — makes the popover read as an intentional detail card. */
.pill-card__side-head {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding-bottom: 0.35rem;
  margin-bottom: 0.1rem;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.pill-card__side-eyebrow {
  font-size: 0.5rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--pill-accent);
  opacity: 0.9;
}
.pill-card__side-title {
  font-size: 0.72rem;
  font-weight: 650;
  color: var(--text-primary, #fff);
  line-height: 1.2;
}
.pill-card__hover-desc--muted {
  color: var(--text-muted, #9ca3af);
  font-style: italic;
}

/* Keystone-synergy bonus block — mirrors the combat bar's "{keystone} synergy"
   section (top divider, label in the keystone's accent). Shown in the gold-card
   side panel so the tree explains the in-combat synergy. */
.pill-card__side-bonus {
  --bonus-color: #fbbf24;
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-top: 0.5rem;
  padding-top: 0.45rem;
  border-top: 1px solid color-mix(in srgb, var(--bonus-color) 32%, rgba(255,255,255,0.08));
}
.pill-card__side-bonus-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
}
.pill-card__side-bonus-label {
  font-size: 0.52rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--bonus-color);
}
.pill-card__side-bonus-state {
  font-size: 0.45rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  white-space: nowrap;
  padding: 1px 5px;
  border-radius: 3px;
  color: var(--text-subtle, #6b7280);
  background: rgba(255,255,255,0.05);
}
.pill-card__side-bonus--active .pill-card__side-bonus-state {
  color: var(--bonus-color);
  background: color-mix(in srgb, var(--bonus-color) 18%, transparent);
}
.pill-card__side-bonus-line {
  margin: 0;
  font-size: 0.6rem;
  line-height: 1.42;
  color: var(--text-secondary, #d1d5db);
}
.pill-card__side-bonus--active .pill-card__side-bonus-line {
  color: var(--text-primary, #fff);
}

/* On narrow viewports the panel could clip off-screen; flip it to the left. */
.pill-card--side-details.pill-card--side-left .pill-card__hover {
  left: auto;
  right: calc(100% + 12px);
  transform: translateX(6px);
  box-shadow: 0 10px 32px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4),
              8px 0 24px rgba(0,0,0,0.3);
}
.pill-card--side-details.pill-card--side-left .pill-card__hover::before {
  left: auto; right: -1px;
}
.pill-card--side-details.pill-card--side-left:hover .pill-card__hover {
  transform: translateX(0);
}

/* ── Equipped variant ── */
.pill-card--equipped {
  border-color: rgba(99,102,241,0.3);
  box-shadow: 0 0 10px rgba(99,102,241,0.08);
}
.pill-card--equipped:hover {
  border-color: rgba(99,102,241,0.5);
  box-shadow: 0 4px 20px rgba(0,0,0,0.3), 0 0 16px rgba(99,102,241,0.12);
}

/* ============================================
   TOOLTIP-ONLY (equip hotbar) — Edward 2026-06-25
   The "what it does" detail panel rendered STANDALONE, no compact-card
   chrome. Same content + visual language as the side-details hover panel,
   but always visible and self-contained: the equip hotbar is a pure-info
   surface, so it shows the tooltip outright; the compact gold ACTION card
   stays on the skill tree where a direct action can be taken.
   ============================================ */
.pill-tooltip {
  --pill-accent: #6366f1;
  position: relative;
  width: 220px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  padding: 0.65rem 0.7rem 0.7rem;
  background: linear-gradient(180deg, rgba(20,20,24,0.98), rgba(12,12,15,0.98));
  border: 1px solid color-mix(in srgb, var(--pill-accent) 30%, rgba(255,255,255,0.08));
  border-radius: var(--radius-md, 8px);
  box-shadow: 0 14px 36px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* Accent rail on the left edge, matching the side-details panel's notch. */
.pill-tooltip::before {
  content: '';
  position: absolute;
  top: 10px; bottom: 10px; left: 0;
  width: 2px;
  border-radius: 2px;
  background: var(--pill-accent);
  opacity: 0.85;
}

.pill-tooltip__head {
  /* Node glyph sits INLINE at the left of the title block (Edward 2026-07-12:
     "remove the circle, display the svg inline with the title header, so it
     doesn't overlap an edge and looks clean"). Row layout is
     [glyph] [eyebrow / title / sub column]. */
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}

/* The header glyph is the drug's BARE skill-tree line-icon (no surrounding ring
   or circle), rendered INLINE at the left of the titles and tinted with the
   card's identity accent — not a floated circular badge. The SVG fills the box
   (100%). Edward 2026-07-12 ("remove the circle, just the svg inline"). */
.pill-tooltip__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  flex: none;
  color: var(--pill-accent, currentColor);
}
.pill-tooltip__icon svg { width: 100%; height: 100%; }

.pill-tooltip__titles {
  display: flex;
  flex-direction: column;
  gap: 1px;
  min-width: 0;
}

.pill-tooltip__sub {
  font-size: 0.55rem;
  font-weight: 600;
  color: var(--text-muted, #9ca3af);
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.pill-tooltip__body {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

/* Two-section keystone tooltip (Edward 2026-06-26): TOP = how the beats work,
   BOTTOM = game effects. The green/red pro/con tags are reserved for the bottom
   section. A hairline divider separates the two, matching the head's underline. */
.pill-tooltip__section {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}
.pill-tooltip__section + .pill-tooltip__section {
  margin-top: 0.15rem;
  padding-top: 0.5rem;
  border-top: 1px solid rgba(255,255,255,0.06);
}
`, "",{"version":3,"sources":["webpack://./src/components/PillCard/PillCard.css"],"names":[],"mappings":"AAAA;;;;;iDAKiD;;AAEjD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAkD;EAClD,+DAA+D;EAC/D,qCAAqC;EACrC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,+EAA+E;AACjF;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM,EAAE,OAAO,EAAE,SAAS;EAC1B,UAAU;EACV,8BAA8B;AAChC;;AAEA,gBAAgB;AAChB,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;AAChD,wBAAwB,sBAAsB,EAAE;;AAEhD,sBAAsB;AACtB;EACE,qCAAqC;EACrC,uEAAuE;EACvE,2BAA2B;AAC7B;;AAEA,wBAAwB,eAAe,EAAE;;AAEzC,mCAAmC;AACnC;EACE,kBAAkB;EAClB,QAAQ,EAAE,UAAU;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA,+BAA+B,gCAAgC,EAAE,cAAc,EAAE;AACjF,+BAA+B,gCAAgC,EAAE,cAAc,EAAE;AACjF,+BAA+B,iCAAiC,EAAE,cAAc,EAAE;;AAElF;;iDAEiD;;AAEjD;;;;;yBAKyB;AACzB;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,0DAA0D;AAC1D;;EAEE,6BAA6B;EAC7B,+BAA+B;AACjC;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mEAAmE;EACnE,yEAAyE;EACzE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;AACf;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,8BAA8B,gCAAgC,EAAE,cAAc,EAAE;AAChF,8BAA8B,iCAAiC,EAAE,cAAc,EAAE;AACjF,8BAA8B,iCAAiC,EAAE,cAAc,EAAE;AACjF,8BAA8B,iCAAiC,EAAE,cAAc,EAAE;;AAEjF;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA,yBAAyB,cAAc,EAAE;;AAEzC;;iDAEiD;;AAEjD,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,SAAS;AACX;;AAEA;;oEAEoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,+DAA+D;EAC/D,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;wEAGwE;AACxE;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;AACA,+DAA+D,cAAc,EAAE;AAC/E,gEAAgE,cAAc,EAAE;AAChF,8DAA8D,cAAc,EAAE;AAC9E,oEAAoE,cAAc,EAAE;;AAEpF,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA,kEAAkE;AAClE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA,iDAAiD,cAAc,EAAE;AACjE,uDAAuD,cAAc,EAAE,QAAQ,EAAE;AACjF;;;+DAG+D;AAC/D,sDAAsD,cAAc,EAAE;AACtE;;iFAEiF;AACjF,wDAAwD,cAAc,EAAE;AACxE,6CAA6C,qBAAqB,EAAE,sBAAsB,EAAE;AAC5F,2CAA2C,kCAAkC,EAAE;;AAE/E,+EAA+E;AAC/E;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB;AACA;EACE,WAAW;EACX,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;AACA,yBAAyB,gCAAgC,EAAE,cAAc,EAAE;AAC3E,yBAAyB,gCAAgC,EAAE,cAAc,EAAE;AAC3E,yBAAyB,iCAAiC,EAAE,cAAc,EAAE;;AAE5E,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA,wDAAwD;AACxD;EACE,kBAAkB;AACpB;AACA,yBAAyB,WAAW,EAAE;;AAEtC,uBAAuB;AACvB;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW,EAAE,YAAY;AAC3B;AACA;EACE,WAAW,EAAE,YAAY;AAC3B;AACA;EACE,qBAAqB;AACvB;;AAEA;;;;iDAIiD;;AAEjD;gDACgD;AAChD,2BAA2B,iBAAiB,EAAE;AAC9C;EACE,8CAA8C;EAC9C,iDAAiD;AACnD;;AAEA;yEACyE;AACzE;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;8CAC8C;AAC9C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,YAAY;EACZ,eAAe,GAAG;6EACyD;EAC3E,uBAAuB;EACvB,6EAA6E;EAC7E,oFAAoF;EACpF,oCAAoC;EACpC;yCACuC;EACvC,2BAA2B;EAC3B,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,sEAAsE;AACxE;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,YAAY,EAAE,UAAU;EACnC,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,qBAAqB;EACrB,+CAA+C;AACjD;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;;2DAE2D;AAC3D;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,oBAAoB;EACpB,wFAAwF;AAC1F;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;AACpC;AACA;EACE,yBAAyB;EACzB,mEAAmE;AACrE;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;;AAEA,8EAA8E;AAC9E;EACE,UAAU;EACV,wBAAwB;EACxB,0BAA0B;EAC1B;wCACsC;AACxC;AACA;EACE,UAAU,EAAE,WAAW;AACzB;AACA;EACE,wBAAwB;AAC1B;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,0CAA0C;AAC5C;AACA;EACE,kCAAkC;EAClC,sEAAsE;AACxE;;AAEA;;;;;;;iDAOiD;AACjD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,6EAA6E;EAC7E,oFAAoF;EACpF,oCAAoC;EACpC,mEAAmE;EACnE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,YAAY,EAAE,OAAO;EAChC,UAAU;EACV,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE;;;8CAG4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;;;0EAG0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,uCAAuC;AACzC;AACA,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;kFAEkF;AAClF;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;AAC9C","sourcesContent":["/* ============================================\n   PillCard — compact golden card\n   Face: icon, ability, drug, drug class\n   Hover: swaps face content for details\n   Action button always accessible\n   ============================================ */\n\n.pill-card {\n  --pill-accent: #6366f1;\n  position: relative;\n  width: 172px;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-card, rgba(255,255,255,0.03));\n  border: 1px solid var(--border-default, rgba(255,255,255,0.08));\n  border-radius: var(--radius-lg, 10px);\n  padding: 0.65rem 0.6rem 0.5rem;\n  overflow: hidden;\n  cursor: default;\n  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.2s ease;\n}\n\n/* Accent stripe */\n.pill-card::before {\n  content: '';\n  position: absolute;\n  top: 0; left: 0; bottom: 0;\n  width: 3px;\n  background: var(--pill-accent);\n}\n\n/* Type colors */\n.pill-card--combat    { --pill-accent: #ef4444; }\n.pill-card--passive   { --pill-accent: #6366f1; }\n.pill-card--consumable{ --pill-accent: #a855f7; }\n\n/* Hover lift + glow */\n.pill-card:hover {\n  border-color: rgba(251, 191, 36, 0.3);\n  box-shadow: 0 6px 24px rgba(0,0,0,0.35), 0 0 12px rgba(251,191,36,0.08);\n  transform: translateY(-2px);\n}\n\n.pill-card--clickable { cursor: pointer; }\n\n/* ── Status badge (top-right) ── */\n.pill-card__badge {\n  position: absolute;\n  top: 5px; right: 5px;\n  font-size: 7px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  padding: 1px 5px;\n  border-radius: 3px;\n  z-index: 2;\n}\n.pill-card__badge--starter   { background: rgba(234,179,8,0.15); color: #fbbf24; }\n.pill-card__badge--owned     { background: rgba(34,197,94,0.15); color: #4ade80; }\n.pill-card__badge--equipped  { background: rgba(99,102,241,0.15); color: #818cf8; }\n\n/* ============================================\n   CONTENT AREA — face and hover swap in place\n   ============================================ */\n\n/* Face and hover stack in the same grid cell so the taller of the two\n   reserves the height. Toggling `visibility` (instead of `display`) keeps\n   the reserved space stable, so hovering can no longer shift the card's\n   height. The non-visible layer stays out of the pointer/a11y tree via\n   `visibility: hidden` (children also hidden), with `pointer-events: none`\n   for belt-and-braces. */\n.pill-card__content {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  display: grid;\n  grid-template-areas: \"swap\";\n}\n\n.pill-card__face,\n.pill-card__hover {\n  grid-area: swap;\n  display: flex;\n  flex-direction: column;\n  padding: 0.15rem 0 0.35rem;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.pill-card__face {\n  align-items: center;\n  text-align: center;\n  gap: 0.25rem;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.pill-card__hover {\n  gap: 0.3rem;\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.pill-card:hover .pill-card__face {\n  visibility: hidden;\n  pointer-events: none;\n}\n\n.pill-card:hover .pill-card__hover {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* Suppress the hover-swap entirely (face stays visible) */\n.pill-card--no-hover .pill-card__hover,\n.pill-card--no-hover:hover .pill-card__hover {\n  visibility: hidden !important;\n  pointer-events: none !important;\n}\n.pill-card--no-hover:hover .pill-card__face {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* Icon ring */\n.pill-card__icon-ring {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--pill-accent) 12%, transparent);\n  border: 1px solid color-mix(in srgb, var(--pill-accent) 25%, transparent);\n  color: var(--pill-accent);\n  flex-shrink: 0;\n}\n\n.pill-card__icon-ring svg {\n  width: 16px;\n  height: 16px;\n}\n\n/* Ability name */\n.pill-card__ability {\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: var(--text-primary, #fff);\n  line-height: 1.15;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Drug name */\n.pill-card__drug-name {\n  font-size: 0.62rem;\n  color: var(--pill-accent);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  opacity: 0.85;\n}\n\n/* Drug class */\n.pill-card__drug-class {\n  font-size: 0.55rem;\n  color: var(--text-muted, #9ca3af);\n  line-height: 1.3;\n  text-align: center;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* ── Footer: type + (optional inline foot action) + cost ── */\n.pill-card__foot {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: auto;\n  padding-top: 0.3rem;\n  border-top: 1px solid rgba(255,255,255,0.04);\n}\n\n.pill-card__foot-action {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 6px;\n  margin-left: auto;\n}\n\n.pill-card__type {\n  font-size: 0.55rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: 1px 5px;\n  border-radius: 3px;\n}\n.pill-card__type--combat    { background: rgba(239,68,68,0.12); color: #f87171; }\n.pill-card__type--passive   { background: rgba(99,102,241,0.12); color: #818cf8; }\n.pill-card__type--consumable{ background: rgba(168,85,247,0.12); color: #c084fc; }\n.pill-card__type--gold      { background: rgba(251,191,36,0.16); color: #fbbf24; }\n\n.pill-card__cost {\n  font-size: 0.6rem;\n  font-weight: 700;\n  color: #fbbf24;\n}\n.pill-card__cost--free { color: #4ade80; }\n\n/* ============================================\n   HOVER CONTENT\n   ============================================ */\n\n/* Hover description */\n.pill-card__hover-desc {\n  font-size: 0.62rem;\n  color: var(--text-secondary, #d1d5db);\n  line-height: 1.4;\n  margin: 0;\n}\n\n/* HTN authored effect grammar. The outer combat-status-rail class supplies the\n   exact status-chip colors; this modifier turns that rail into the drug card's\n   vertical row block without introducing replacement chip chrome. */\n.pill-card__influence-rows.combat-status-rail {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  flex-wrap: nowrap;\n  gap: 8px;\n  min-height: 0;\n  margin: 0.2rem 0 0;\n  padding: 0.5rem 0 0;\n  border: 0;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 0;\n  background: none;\n  color: var(--text-secondary, #d1d5db);\n  font-size: 0.68rem;\n  line-height: 1.35;\n}\n\n.pill-card__influence-row {\n  min-width: 0;\n}\n\n.pill-card__influence-row--regen {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 0;\n}\n\n.pill-card__influence-verb,\n.pill-card__influence-rows .gt-text {\n  color: var(--text-secondary, #d1d5db);\n  font-weight: 700;\n}\n\n.pill-card__influence-row--warden {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 6px;\n  padding: 7px 0;\n}\n\n.pill-card__warden-mini {\n  flex: 1 1 auto;\n  grid-template-columns: minmax(112px, 1fr);\n  min-width: 0;\n  margin-top: 0;\n}\n\n.pill-card--side-details-layout .pill-card__influence-row--warden {\n  display: grid;\n  grid-template-columns: minmax(112px, 0.42fr) minmax(142px, 1fr);\n  align-items: center;\n  gap: 14px;\n}\n\n.pill-card__influence-rows .gt-inflicts {\n  padding: 7px 0;\n}\n\n.pill-card__influence-rows .gt-inflicts__r {\n  max-width: 58%;\n}\n\n/* ── Authored HTN starter drug-toast rows (kc-pill family) ──────────────────\n   Faithful port of ref-toasts/antihtn-authored-2026-07-19.html. Every row is a\n   uniform label-left / tag-right space-between line; verbs are semantic-colored;\n   potassium/HR/diuresis render the shared reference `kc-pill` chrome. */\n.pill-card__influence-rows .pill-card__influence-row--kc {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 14px;\n  padding: 0;\n}\n\n.pill-card__influence-rows .pill-card__influence-verb {\n  margin: 0;\n  font-weight: 700;\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n}\n.pill-card__influence-rows .pill-card__influence-verb--regen { color: #86efac; }\n.pill-card__influence-rows .pill-card__influence-verb--strong { color: #f87171; }\n.pill-card__influence-rows .pill-card__influence-verb--weak { color: #fb923c; }\n.pill-card__influence-rows .pill-card__influence-verb--influences { color: #d1d5db; }\n\n/* Regen chip right group: [hp chip] / round */\n.pill-card__influence-rows .pill-card__influence-row--kc .gt-inflicts__r {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  max-width: none;\n  flex: 0 0 auto;\n}\n\n/* Qualifier group: \"( <glyph> compensatory )\" / \"( <glyph> 5 )\" */\n.pill-card__influence-rows .kc-qual {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  color: #9ca3af;\n  font-weight: 700;\n  margin-left: 3px;\n}\n.pill-card__influence-rows .kc-qual__inner {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n.pill-card__influence-rows .kc-qual__inner--hr { color: #fb7185; }\n.pill-card__influence-rows .kc-qual__inner--diuresis { color: #2dd4bf; gap: 3px; }\n/* Remodel takes the sympathetic-axis green (AXIS_DEFAULTS.beta accent), the same\n   colour its own effect chip paints, so the qualifier and the chip read as one\n   claim rather than two. Compensatory is rose because heart RATE is rose; Remodel\n   is not a heart-rate claim and must not borrow that colour. */\n.pill-card__influence-rows .kc-qual__inner--remodel { color: #4ade80; }\n/* Mortality Benefit takes the Good Outcome teal its own chip paints (the\n   CanonicalEffectChip tone=\"good\" accent, 45,212,160), so the qualifier and the\n   chip read as one claim. It is a HEAL, so it must not borrow Remodel's green. */\n.pill-card__influence-rows .kc-qual__inner--mortality { color: #2dd4a0; }\n.pill-card__influence-rows .kc-qual__glyph { display: inline-block; vertical-align: middle; }\n.pill-card__influence-rows .kc-qual__num { font-variant-numeric: tabular-nums; }\n\n/* Weaken-row enemy mini: right-aligned fixed-width ledger, per the reference */\n.pill-card__influence-rows .pill-card__hover-tags--ledger {\n  flex: 0 0 228px;\n  max-width: 228px;\n  margin: 0;\n  display: block;\n}\n.pill-card__influence-rows .pill-card__hover-tags--ledger .pill-card__warden-mini {\n  width: 100%;\n  grid-template-columns: 1fr;\n  flex: 1 1 auto;\n}\n\n/* Hover tags */\n.pill-card__hover-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.pill-card__htag {\n  font-size: 0.55rem;\n  font-weight: 600;\n  padding: 1px 5px;\n  border-radius: 3px;\n  max-width: 100%;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n.pill-card__htag--pro  { background: rgba(34,197,94,0.15); color: #4ade80; }\n.pill-card__htag--con  { background: rgba(239,68,68,0.15); color: #f87171; }\n.pill-card__htag--mech { background: rgba(245,158,11,0.12); color: #fbbf24; }\n\n/* Achievement requirement in hover */\n.pill-card__hover-req {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border-top: 1px solid rgba(255,255,255,0.05);\n  padding-top: 0.25rem;\n}\n\n.pill-card__hover-req-name {\n  font-size: 0.5rem;\n  color: var(--text-muted, #9ca3af);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 55%;\n}\n\n.pill-card__hover-req-bar {\n  flex: 1;\n  height: 3px;\n  background: rgba(255,255,255,0.06);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.pill-card__hover-req-fill {\n  height: 100%;\n  background: var(--text-muted, #9ca3af);\n  border-radius: 2px;\n  transition: width 0.3s ease;\n}\n\n.pill-card__hover-req-label {\n  font-size: 0.5rem;\n  color: var(--text-subtle, #6b7280);\n  white-space: nowrap;\n}\n\n/* ── Action button (always visible, never covered) ── */\n.pill-card__action {\n  margin-top: 0.3rem;\n}\n.pill-card__action > * { width: 100%; }\n\n/* ── Mini variant ── */\n.pill-card--mini {\n  width: 140px;\n  padding: 0.5rem;\n}\n.pill-card--mini .pill-card__icon-ring {\n  width: 26px; height: 26px;\n}\n.pill-card--mini .pill-card__icon-ring svg {\n  width: 13px; height: 13px;\n}\n.pill-card--mini .pill-card__drug-class {\n  -webkit-line-clamp: 1;\n}\n\n/* ============================================\n   SIDE-DETAILS variant — effect details slide OUT to the right on hover,\n   the compact face stays put and fixed-size. Used by the skill-tree node\n   toast so a gold card reveals \"what it does\" without growing or flipping.\n   ============================================ */\n\n/* Let the side panel escape the card's clip; round the accent stripe so the\n   now-visible corners follow the card radius. */\n.pill-card--side-details { overflow: visible; }\n.pill-card--side-details::before {\n  border-top-left-radius: var(--radius-lg, 10px);\n  border-bottom-left-radius: var(--radius-lg, 10px);\n}\n\n/* With the details lifted out of the grid, only the face reserves height →\n   the card stays compact regardless of how much detail a card carries. */\n.pill-card--side-details .pill-card__face {\n  visibility: visible;\n  pointer-events: auto;\n}\n.pill-card--side-details:hover .pill-card__face {\n  visibility: visible;\n  pointer-events: auto;\n}\n\n/* The details block becomes a floating panel anchored to the card's right\n   edge. Hidden until hover, then slides in. */\n.pill-card--side-details .pill-card__hover {\n  position: absolute;\n  grid-area: unset;\n  top: -2px;\n  left: calc(100% + 12px);\n  width: 210px;\n  max-width: none;  /* override the base .pill-card__hover max-width:100% (would cap\n                       the floating panel to the card's inner width ~151px) */\n  padding: 0.6rem 0.65rem;\n  background: linear-gradient(180deg, rgba(20,20,24,0.98), rgba(12,12,15,0.98));\n  border: 1px solid color-mix(in srgb, var(--pill-accent) 28%, rgba(255,255,255,0.08));\n  border-radius: var(--radius-md, 8px);\n  box-shadow: 0 10px 32px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4),\n              -8px 0 24px rgba(0,0,0,0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  z-index: 60;\n  visibility: hidden;\n  opacity: 0;\n  transform: translateX(-6px);\n  transition: opacity 0.14s ease, transform 0.14s ease, visibility 0.14s;\n}\n\n/* Little notch / accent rail on the panel's left edge facing the card. */\n.pill-card--side-details .pill-card__hover::before {\n  content: '';\n  position: absolute;\n  top: 10px; bottom: 10px; left: -1px;\n  width: 2px;\n  border-radius: 2px;\n  background: var(--pill-accent);\n  opacity: 0.85;\n}\n\n.pill-card--side-details:hover .pill-card__hover {\n  visibility: visible;\n  opacity: 1;\n  transform: translateX(0);\n  pointer-events: auto;\n}\n\n/* Panel header — makes the popover read as an intentional detail card. */\n.pill-card__side-head {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding-bottom: 0.35rem;\n  margin-bottom: 0.1rem;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n.pill-card__side-eyebrow {\n  font-size: 0.5rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--pill-accent);\n  opacity: 0.9;\n}\n.pill-card__side-title {\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: var(--text-primary, #fff);\n  line-height: 1.2;\n}\n.pill-card__hover-desc--muted {\n  color: var(--text-muted, #9ca3af);\n  font-style: italic;\n}\n\n/* Keystone-synergy bonus block — mirrors the combat bar's \"{keystone} synergy\"\n   section (top divider, label in the keystone's accent). Shown in the gold-card\n   side panel so the tree explains the in-combat synergy. */\n.pill-card__side-bonus {\n  --bonus-color: #fbbf24;\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  margin-top: 0.5rem;\n  padding-top: 0.45rem;\n  border-top: 1px solid color-mix(in srgb, var(--bonus-color) 32%, rgba(255,255,255,0.08));\n}\n.pill-card__side-bonus-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n}\n.pill-card__side-bonus-label {\n  font-size: 0.52rem;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: var(--bonus-color);\n}\n.pill-card__side-bonus-state {\n  font-size: 0.45rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  white-space: nowrap;\n  padding: 1px 5px;\n  border-radius: 3px;\n  color: var(--text-subtle, #6b7280);\n  background: rgba(255,255,255,0.05);\n}\n.pill-card__side-bonus--active .pill-card__side-bonus-state {\n  color: var(--bonus-color);\n  background: color-mix(in srgb, var(--bonus-color) 18%, transparent);\n}\n.pill-card__side-bonus-line {\n  margin: 0;\n  font-size: 0.6rem;\n  line-height: 1.42;\n  color: var(--text-secondary, #d1d5db);\n}\n.pill-card__side-bonus--active .pill-card__side-bonus-line {\n  color: var(--text-primary, #fff);\n}\n\n/* On narrow viewports the panel could clip off-screen; flip it to the left. */\n.pill-card--side-details.pill-card--side-left .pill-card__hover {\n  left: auto;\n  right: calc(100% + 12px);\n  transform: translateX(6px);\n  box-shadow: 0 10px 32px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4),\n              8px 0 24px rgba(0,0,0,0.3);\n}\n.pill-card--side-details.pill-card--side-left .pill-card__hover::before {\n  left: auto; right: -1px;\n}\n.pill-card--side-details.pill-card--side-left:hover .pill-card__hover {\n  transform: translateX(0);\n}\n\n/* ── Equipped variant ── */\n.pill-card--equipped {\n  border-color: rgba(99,102,241,0.3);\n  box-shadow: 0 0 10px rgba(99,102,241,0.08);\n}\n.pill-card--equipped:hover {\n  border-color: rgba(99,102,241,0.5);\n  box-shadow: 0 4px 20px rgba(0,0,0,0.3), 0 0 16px rgba(99,102,241,0.12);\n}\n\n/* ============================================\n   TOOLTIP-ONLY (equip hotbar) — Edward 2026-06-25\n   The \"what it does\" detail panel rendered STANDALONE, no compact-card\n   chrome. Same content + visual language as the side-details hover panel,\n   but always visible and self-contained: the equip hotbar is a pure-info\n   surface, so it shows the tooltip outright; the compact gold ACTION card\n   stays on the skill tree where a direct action can be taken.\n   ============================================ */\n.pill-tooltip {\n  --pill-accent: #6366f1;\n  position: relative;\n  width: 220px;\n  max-width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  padding: 0.65rem 0.7rem 0.7rem;\n  background: linear-gradient(180deg, rgba(20,20,24,0.98), rgba(12,12,15,0.98));\n  border: 1px solid color-mix(in srgb, var(--pill-accent) 30%, rgba(255,255,255,0.08));\n  border-radius: var(--radius-md, 8px);\n  box-shadow: 0 14px 36px rgba(0,0,0,0.55), 0 0 0 1px rgba(0,0,0,0.4);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n/* Accent rail on the left edge, matching the side-details panel's notch. */\n.pill-tooltip::before {\n  content: '';\n  position: absolute;\n  top: 10px; bottom: 10px; left: 0;\n  width: 2px;\n  border-radius: 2px;\n  background: var(--pill-accent);\n  opacity: 0.85;\n}\n\n.pill-tooltip__head {\n  /* Node glyph sits INLINE at the left of the title block (Edward 2026-07-12:\n     \"remove the circle, display the svg inline with the title header, so it\n     doesn't overlap an edge and looks clean\"). Row layout is\n     [glyph] [eyebrow / title / sub column]. */\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding-bottom: 0.4rem;\n  border-bottom: 1px solid rgba(255,255,255,0.06);\n}\n\n/* The header glyph is the drug's BARE skill-tree line-icon (no surrounding ring\n   or circle), rendered INLINE at the left of the titles and tinted with the\n   card's identity accent — not a floated circular badge. The SVG fills the box\n   (100%). Edward 2026-07-12 (\"remove the circle, just the svg inline\"). */\n.pill-tooltip__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  flex: none;\n  color: var(--pill-accent, currentColor);\n}\n.pill-tooltip__icon svg { width: 100%; height: 100%; }\n\n.pill-tooltip__titles {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  min-width: 0;\n}\n\n.pill-tooltip__sub {\n  font-size: 0.55rem;\n  font-weight: 600;\n  color: var(--text-muted, #9ca3af);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.pill-tooltip__body {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n/* Two-section keystone tooltip (Edward 2026-06-26): TOP = how the beats work,\n   BOTTOM = game effects. The green/red pro/con tags are reserved for the bottom\n   section. A hairline divider separates the two, matching the head's underline. */\n.pill-tooltip__section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n.pill-tooltip__section + .pill-tooltip__section {\n  margin-top: 0.15rem;\n  padding-top: 0.5rem;\n  border-top: 1px solid rgba(255,255,255,0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
